import { alkymetricsClient } from '../alkymetricsClient';

export const updateNotification = async (workspaceId, partnerId, request) => {
  const { data } = await alkymetricsClient.patch(
    `/partner-to-workspace-to-notifications/${workspaceId}/${partnerId}`,
    request
  );
  return data;
};
